module.exports = __webpack_public_path__ + "static/media/thumbnail_advincula-for-use@3x.cb86ddad.jpg";